import { CardHolderServiceInterface } from "interfaces/card-holder-service"
import { ProfileServiceInterface } from "interfaces/profile-service"
import { StationsServiceInterface } from "interfaces/stations-service"
import { InvoiceServiceInterface } from "interfaces/invoice-service"
import { RfidServiceInterface } from "interfaces/rfid-service"
import { PaymentServiceInterface } from "interfaces/payment-service"
import { SessionsServiceInterface } from "interfaces/sessions-service"
import { ChargingRulesServiceInterface } from "interfaces/charging-rules-service"
import { RfidRuleServiceInterface } from "interfaces/rfidRule-service"
import { OrganizationServiceInterface } from "interfaces/organization-service"
import { SupportServiceInterface } from "./support-service.ts"

export interface MmsServiceInterface {
    cardHolderService: CardHolderServiceInterface
    stationsService: StationsServiceInterface
    profileService: ProfileServiceInterface
    invoiceService: InvoiceServiceInterface
    paymentService: PaymentServiceInterface
    rfidService: RfidServiceInterface
    rfidRuleService: RfidRuleServiceInterface
    sessionsService: SessionsServiceInterface
    chargingRulesService: ChargingRulesServiceInterface
    organizationService: OrganizationServiceInterface
    getCardholderService: () => CardHolderServiceInterface
    getStationsService: () => StationsServiceInterface
    getProfileService: () => ProfileServiceInterface
    getInvoiceService: () => InvoiceServiceInterface
    getRfidService: () => RfidServiceInterface
    getRfidRuleService: () => RfidRuleServiceInterface
    getPaymentService: () => PaymentServiceInterface
    getSessionsService: () => SessionsServiceInterface
    getChargingRulesService: () => ChargingRulesServiceInterface
    getOrganizationService: () => OrganizationServiceInterface
    supportService: SupportServiceInterface
    getSupportService: () => SupportServiceInterface
}

interface MmsServiceConstructorProps {
    cardHolderService: CardHolderServiceInterface
    stationsService: StationsServiceInterface
    profileService: ProfileServiceInterface
    invoiceService: InvoiceServiceInterface
    sessionsService: SessionsServiceInterface
    rfidService: RfidServiceInterface
    rfidRuleService: RfidRuleServiceInterface
    paymentService: PaymentServiceInterface
    chargingRulesService: ChargingRulesServiceInterface
    organizationService: OrganizationServiceInterface
    supportService: SupportServiceInterface
}

export abstract class MmsService implements MmsServiceInterface {
    cardHolderService: CardHolderServiceInterface
    stationsService: StationsServiceInterface
    profileService: ProfileServiceInterface
    invoiceService: InvoiceServiceInterface
    sessionsService: SessionsServiceInterface
    rfidService: RfidServiceInterface
    rfidRuleService: RfidRuleServiceInterface
    paymentService: PaymentServiceInterface
    chargingRulesService: ChargingRulesServiceInterface
    organizationService: OrganizationServiceInterface
    supportService: SupportServiceInterface

    constructor({
        cardHolderService,
        stationsService,
        profileService,
        invoiceService,
        rfidService,
        rfidRuleService,
        paymentService,
        sessionsService,
        chargingRulesService,
        organizationService,
        supportService,
    }: MmsServiceConstructorProps) {
        this.cardHolderService = cardHolderService
        this.stationsService = stationsService
        this.profileService = profileService
        this.invoiceService = invoiceService
        this.rfidService = rfidService
        this.rfidRuleService = rfidRuleService
        this.paymentService = paymentService
        this.sessionsService = sessionsService
        this.chargingRulesService = chargingRulesService
        this.organizationService = organizationService
        this.supportService = supportService
    }

    // Conform to interface spelling
    getCardholderService = () => this.cardHolderService
    // Backward-compatible alias (if some parts of the app still use this name)
    getCardHolderService = () => this.cardHolderService
    getStationsService = () => this.stationsService
    getProfileService = () => this.profileService
    getInvoiceService = () => this.invoiceService
    getRfidService = () => this.rfidService
    getRfidRuleService = () => this.rfidRuleService
    getPaymentService = () => this.paymentService
    getSessionsService = () => this.sessionsService
    getChargingRulesService = () => this.chargingRulesService
    getOrganizationService = () => this.organizationService
    getSupportService = () => this.supportService
}
